import { useMemo } from "react";

interface DropSpec {
  left: number; // percentage 0-100
  size: number; // px
  duration: number; // s
  delay: number; // s
  opacity: number; // 0-1
  blur: number; // px
}

const generateDrops = (count: number): DropSpec[] => {
  const drops: DropSpec[] = [];
  for (let i = 0; i < count; i++) {
    drops.push({
      left: Math.random() * 100,
      size: Math.floor(6 + Math.random() * 12),
      duration: 6 + Math.random() * 10,
      delay: Math.random() * 8,
      opacity: 0.08 + Math.random() * 0.12,
      blur: Math.floor(Math.random() * 3),
    });
  }
  return drops;
};

export default function LightRain({ count = 48 }: { count?: number }) {
  const drops = useMemo(() => generateDrops(count), [count]);

  return (
    <div className="light-rain-overlay pointer-events-none fixed inset-0 z-20">
      <div className="absolute inset-0 overflow-hidden">
        {drops.map((d, idx) => (
          <span
            key={idx}
            className="block absolute rounded-full will-change-transform"
            style={{
              left: `${d.left}%`,
              top: `-15vh`,
              width: d.size,
              height: d.size,
              filter: d.blur ? `blur(${d.blur}px)` : undefined,
              background:
                "radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0.7) 35%, rgba(255,255,255,0.2) 60%, rgba(255,255,255,0) 70%)",
              opacity: d.opacity,
              animation: `light-rain-fall ${d.duration}s linear ${d.delay}s infinite`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
